import { useSearchParams } from "react-router-dom";
import { useUserShowQuery } from "@/admin/entities/users";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

/**
 * Feature-специфичные хуки для управления пользователями
 * Комбинируют entity-логику с UI-специфичными потребностями
 */

/**
 * Основной хук для feature управления пользователями
 * Предоставляет всю необходимую конфигурацию и логику для UI компонента
 */
export function useUsersManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  // Используем entity хук для загрузки данных пользователя
  useUserShowQuery(id, id === null);

  return {
    // Конфигурация таблицы
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,

    // Трансформация данных
    getTableData,

    // Текстовые метки
    texts: getTextsConfig(),
  };
}

/**
 * Хук для получения конфигурации колонок таблицы
 */
export function useUsersTableConfig() {
  return {
    columns: getColumnsConfig(),
    mapColumns,
  };
}

/**
 * Хук для получения текстовых меток интерфейса
 */
export function useUsersTexts() {
  return getTextsConfig();
}
